import React, { useCallback, useContext, useEffect, useState } from 'react'
import { MdRefresh, MdOutlineEventBusy } from 'react-icons/md'
import { BASE_URL_API } from '../../References/URLs'
import AuthContext from '../../store/auth-context'
import styles from '../Users/AllVisitsWrapper.module.css'
import EachVisitWrapper from './EachVisitWrapper'

const AllVisitsWrapper = props => {
    const authCtx = useContext(AuthContext)
    const clientStoreRelationIdentifier = props.clientStoreRelationIdentifier
    const [allTransactions, setAllTransactions] = useState([])
    const [loading, setLoading] = useState(true)

    const getAllClientVisits = useCallback(async () => {
        setLoading(true)
        const getAllClientVisitsResponse = await fetch(BASE_URL_API + "getAllClientVisits",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    clientStoreRelationIdentifier: clientStoreRelationIdentifier
                })
            });

        if (!getAllClientVisitsResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const getAllClientVisitsRespo = await getAllClientVisitsResponse.json();
            if (getAllClientVisitsRespo.status === 'success') {
                setAllTransactions(getAllClientVisitsRespo.response)
            } else {
                if (getAllClientVisitsRespo.message === 'tokenExpired') {
                    authCtx.logout()
                } else {
                    setAllTransactions([])
                }
            }
        }
        setLoading(false)
    }, [authCtx, clientStoreRelationIdentifier])

    useEffect(() => {
        if (clientStoreRelationIdentifier !== undefined) {
            getAllClientVisits()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientStoreRelationIdentifier])


    return (
        <div className={styles.wrapper}>
            <div className={styles.rightHeader}>
                <div className={styles.rhTitle}>
                    All Visits {!loading && <span className={styles.countBadge}>({allTransactions.length})</span>}
                </div>
                <button
                    type="button"
                    className={styles.refreshBtn}
                    onClick={getAllClientVisits}
                    disabled={loading}
                    aria-label="Refresh"
                >
                    <MdRefresh size={16} className={loading ? styles.spinning : ''} />
                </button>
            </div>
            <div className={styles.rightBody}>
                {loading && (
                    <div className={styles.stateWrap}>
                        <MdRefresh size={16} className={styles.spinning} />
                        <span>Loading visits…</span>
                    </div>
                )}

                {!loading && allTransactions.length === 0 && (
                    <div className={styles.emptyState}>
                        <MdOutlineEventBusy size={20} />
                        <span>No visits recorded for this client yet.</span>
                    </div>
                )}

                {!loading && allTransactions.map((item, index) => (
                    <EachVisitWrapper
                        item={item}
                        key={item?.bookingId ?? index}
                    />
                ))}
            </div>
        </div>
    )
}

export default AllVisitsWrapper
